import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTheme } from "../theme/ThemeProvider";
import ThemeToggle from "./ThemeToggle";

/* ------- HEADER 관련 ------- */
export const HEADER_HEIGHT = 60;
export const HEADER_BOTTOM = 30;

interface HeaderProps {
    title: string,
}

const Head = styled.div`
  background: ${props => props.theme.HEADER.BACKGROUND};
  backdrop-filter: blur(12px);

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 2rem;
  width: 100%;
  height: ${HEADER_HEIGHT}px;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  padding: 0 4rem;
  box-sizing: border-box; // padding이 너비에 포함되게끔
`;

const BlogName = styled.h1`
  font-size: 1.5rem;
  font-weight: 800;
  color: ${props => props.theme.HEADER.BLOG_NAME};
  letter-spacing: -1px;
  cursor: pointer;
`;

function Header ({title}:HeaderProps) {
    const { theme, toggle } = useTheme();

    const navigate = useNavigate();
    return (
        <Head>
            <BlogName onClick={() => navigate("/")}>{title}</BlogName>
            <ThemeToggle toggle={toggle} mode={theme} />
        </Head>
    )
}

export default Header;